// extracted by mini-css-extract-plugin
module.exports =  {"promo":"a10a3f92e9--promo--YRfGB","promo-icon":"a10a3f92e9--promo-icon--buaj5","inner":"a10a3f92e9--inner--pbD8W","chevron":"a10a3f92e9--chevron--A6ZR3"};